// @ts-nocheck
import { useState } from 'react';
import { Bot, Eye, Loader2, Sparkles } from 'lucide-react';
import { toast } from 'sonner';
import { createFlow } from '@/service/aiAgentApi';
import FlowViewer from './FlowViewer';
import { c } from './ui';


function parseSavedFlow(raw) {
  let v = raw;
  if (typeof v === 'string') {
    try {
      v = JSON.parse(v);
    } catch {
      return null;
    }
  }
  if (v && !Array.isArray(v.nodes)) v = v.data || v.flow || v;
  return v && Array.isArray(v.nodes) && v.nodes.length ? v : null;
}

export default function FlowCard({ controlRef, buildPayload, agentName, onFlowGenerated, instructions = [], selectedKbId = '', flowGenerated, readOnly, canPublish, saving, onPublish, onGoTo, initialFlow = null }) {
  const [generating, setGenerating] = useState(false);
  const [flow, setFlow] = useState(() => parseSavedFlow(initialFlow));
  const [show, setShow] = useState(false);
  const [fresh, setFresh] = useState(false);

  const hasKb = Boolean(selectedKbId);
  const hasInstr = instructions.some((i) => i.enabled !== false && i.body?.trim());
  const missing = [!hasKb && 'a knowledge base', !hasInstr && 'an instruction'].filter(Boolean);
  const canGenerate = missing.length === 0;
  const missingLabel = missing.length > 1 ? `${missing.slice(0, -1).join(', ')} and ${missing[missing.length - 1]}` : missing[0];

  const generate = async () => {
    if (!hasKb) return toast.error('Please select a knowledge base before generating the flow');
    if (!hasInstr) return toast.error('Please add at least one instruction before generating the flow');
    const payload = buildPayload ? buildPayload() : null;
    if (!payload) return toast.error('Nothing to generate a flow from yet.');
    setGenerating(true);
    try {
      const result = await createFlow(payload, 'json');
      setFlow(result);
      setFresh(true);
      setShow(true);
      toast.success('Flow chart generated');
      onFlowGenerated?.(result);
    } catch (error) {
      toast.error(typeof error === 'string' ? error : 'Failed to generate flow chart');
    } finally {
      setGenerating(false);
    }
  };


  if (controlRef) controlRef.current = { generate, canGenerate };

  return (
    <div className={c('card flowcard')} id="ags-flowcard">
      <div className={c('botwrap')}>
        <span className={c('bot')} aria-hidden>
          <Bot className="ags-i" />
          <Sparkles className={c('spark')} />
        </span>
        <h3>Flow chart</h3>
        <p className={c('note')}>
          {flowGenerated ? 'Generated. Generate again after changes.' : 'An interactive map of how your agent handles a call. Needed before you can publish.'}
        </p>
      </div>
      <button type="button" className={c('btn green')} style={{ width: '100%', justifyContent: 'center' }} onClick={generate} disabled={generating || !canGenerate || readOnly}>
        {generating ? <Loader2 className="ags-i" style={{ animation: 'ags-spin 1s linear infinite' }} /> : <Sparkles className="ags-i" />}
        {generating ? 'Generating…' : flowGenerated ? 'Generate again' : 'Generate flow chart'}
      </button>
      {!canGenerate && <div className={c('note')} style={{ marginTop: 10 }}>Add {missingLabel} to enable the flow chart.</div>}
      {flow && !generating && (
        <button type="button" className={c('btn small keep')} style={{ marginTop: 10 }} onClick={() => { setFresh(false); setShow(true); }}>
          <Eye className="ags-i" /> View last flow chart
        </button>
      )}
      <FlowViewer
        open={show}
        onClose={() => {
          setShow(false);
          setFresh(false);
        }}
        flow={flow}
        agentName={agentName}
        fresh={fresh}
        generating={generating}
        onGenerate={canGenerate && !readOnly ? generate : null}
        canPublish={canPublish}
        saving={saving}
        onPublish={onPublish}
        onGoTo={onGoTo}
      />
    </div>
  );
}

